import { Option } from 'src/components/SelectBox';
import { InsightType } from 'src/interfaces/agent.interface';

export const INSIGHT_TYPE_LABELS: Record<InsightType, string> = {
  [InsightType.BOOLEAN]: 'Yes / No',
  [InsightType.NUMBER]: 'Number',
  [InsightType.ENUM]: 'Selector',
  [InsightType.STRING]: 'Text',
};

export const INSIGHT_TYPE_OPTIONS: Option[] = (
  Object.values(InsightType) as InsightType[]
).map((type) => ({
  value: type,
  label: INSIGHT_TYPE_LABELS[type],
}));

export const getInsightTypeLabel = (type: InsightType): string =>
  INSIGHT_TYPE_LABELS[type];
